import FrustratedPenguinAndErrorDocumentSvg from "./frustrated-penguin-and-error-document.svg";

export const FrustratedPenguinAndErrorDocument = () => {
  return <FrustratedPenguinAndErrorDocumentSvg />;
};
